import axios from "axios"
import { BaseUrl, JsonConfig } from "./BaseRepository"
import { ErrorMessage } from "../Utils/Utils";

//Api call for  Getting Total users
export const GetUsers = async () => {
    try {
        const Url = BaseUrl + "UserManagement/GetUsers";
        const Response = await axios.get(Url, JsonConfig);

        const JsonResponse = Response !== null ? JSON.parse(Response.data) : null;

        if (JsonResponse != null) {
            if (JsonResponse.StatusCode === 200) {
                return JSON.parse(JsonResponse.Payload);
            }
            else {
                ErrorMessage(JsonResponse.Message);
                return null;
            }
        }
        else {
            ErrorMessage("Unable to resolve request");
            return null;
        }

    }
    catch (error) {
        ErrorMessage("Unable to resolve request");
        return null;
    }
}

//Api call For Creating a new user
export const CreateUser = async (NewUser) => {
    try {
        const Url = BaseUrl + "UserManagement/AddUser";
        const Response = await axios.post(Url, NewUser, JsonConfig);

        const JsonResponse = Response !== null ? JSON.parse(Response.data) : null;
        if (JsonResponse != null) {
            if (JsonResponse.StatusCode === 200) {
                return JsonResponse.Message;
            }
            else {
                ErrorMessage(JsonResponse.Message);
                return null;
            }
        }
        else {
            ErrorMessage("Unable to resolve request");
            return null;
        }
    }
    catch (error) {
        ErrorMessage("Unable to resolve request");
        return null;
    }
}

//Api call To Update user information
export const UpdateUser = async (User) => {
    try {
        const Url = BaseUrl + "UserManagement/UpdateUser";
        const Response = await axios.put(Url, User, JsonConfig);

        const JsonResponse = Response !== null ? JSON.parse(Response.data) : null;
        if (JsonResponse != null) {
            if (JsonResponse.StatusCode === 200) {
                return JsonResponse.Message;
            }
            else {
                
                ErrorMessage(JsonResponse.Message);
                return null;
            }
        }
        else {
            ErrorMessage("Unable to resolve request");
            return null;
        }
    }
    catch (error) {
        ErrorMessage("Unable to resolve request");
        return null;
    }
}

//Api call for Deleting a user
export const DeleteUser = async (UserId) => {
    try {
        const Url = BaseUrl + `UserManagement/DeleteUser?userId=${UserId}`;
        const Response = await axios.delete(Url, JsonConfig);

        const JsonResponse = Response !== null ? JSON.parse(Response.data) : null;
        if (JsonResponse != null) {
            if (JsonResponse.StatusCode === 200) {
                return JsonResponse.Message;
            }
            else {
                ErrorMessage(JsonResponse.Message);
                return null;
            }
        }
        else {
            ErrorMessage("Unable to resolve request");
            return null;
        }
    }
    catch (error) {
        ErrorMessage("Unable to resolve request");
        return null;
    }
}